import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwartaxiservice() {



  const cardData =
  {
    keyword: 'Pune to Mahabaleshwar Taxi Service',
    heading: 'Sanavi Travels: Pune to Mahabaleshwar Taxi Service',
    headingDescription: 'Sanavi Travels offers reliable Pune to Mahabaleshwar Taxi Service, providing safe, comfortable, and hassle-free transportation for families, couples, corporate travelers, and tourist groups planning a scenic trip from Pune to Mahabaleshwar. Our fleet of well-maintained sedans, SUVs, and luxury taxis ensures spacious seating, air-conditioning, and ample luggage space for a smooth and enjoyable hill-station journey. With professional chauffeurs, flexible one-way and round-trip taxi packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Mahabaleshwar attractions such as Venna Lake, Mapro Garden, Arthur’s Seat, Wilson Point, Panchgani, and Pratapgad Fort. Choose Sanavi Travels for trusted Pune to Mahabaleshwar taxi services, delivering comfort, safety, and a memorable travel experience.',

    top: 'Top Places to Visit in Mahabaleshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is one of the most popular attractions in Mahabaleshwar, offering boating, horse riding, and scenic walking paths. Surrounded by lush greenery and hills, it is a favorite spot for families, couples, and nature lovers seeking relaxation and beautiful views."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is a famous viewpoint known as the 'Queen of Points' in Mahabaleshwar. It offers breathtaking views of deep valleys, the Savitri River, and surrounding hills. The point is especially popular during sunrise and sunset for its dramatic landscapes."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is named after a rock formation resembling an elephant’s head. This viewpoint provides panoramic views of the Sahyadri ranges and lush valleys. It is a favorite spot for photography and enjoying cool mountain breezes."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic fort near Mahabaleshwar, famous for the battle between Chhatrapati Shivaji Maharaj and Afzal Khan. The fort features temples, watchtowers, and stunning viewpoints, making it a major attraction for history enthusiasts and trekkers."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a popular tourist spot known for its strawberry-based products, fresh juices, and food outlets. Visitors enjoy garden walks, shopping for local products, and tasting Mahabaleshwar’s famous strawberries and chocolates."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a scenic waterfall located near Mahabaleshwar, especially impressive during the monsoon season. Surrounded by dense forests and misty hills, it is a favorite destination for nature lovers and photographers."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point is the highest point in Mahabaleshwar and a popular spot for sunrise views. Visitors can enjoy panoramic vistas of surrounding hills and valleys. It is a peaceful location ideal for early morning visits and photography."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple is an ancient temple dedicated to Lord Shiva and is one of the region’s spiritual highlights. Built in the Hemadpanthi architectural style, it attracts devotees and tourists interested in religious heritage."
  },
  {
    "title": "Kate’s Point and Echo Point",
    "description": "Kate’s Point offers spectacular views of the Dhom Dam and Krishna Valley, while nearby Echo Point is known for its natural echo phenomenon. Together, these points are popular for sightseeing, photography, and enjoying the cool hill-station climate."
  },
  {
    "title": "Panchganga Temple",
    "description": "Panchganga Temple marks the origin of five rivers – Krishna, Venna, Koyna, Gayatri, and Savitri. The temple holds religious importance and offers a serene environment for meditation and spiritual reflection."
  }
]
,




"services": [
  {
    "name": "Pune to Mahabaleshwar Taxi Service",
    "description": "Pune to Mahabaleshwar Taxi Service offers a comfortable, safe, and reliable travel solution for travelers planning a scenic hill station journey. Fully air-conditioned taxis with spacious seating, smooth suspension, and ample luggage space make long drives relaxing and enjoyable. Professional chauffeurs with experience on ghat roads ensure safe driving, timely pickups, and smooth navigation. Ideal for families, couples, tourists, and corporate travelers, this service is perfect for weekend trips, holidays, and leisure travel to Mahabaleshwar."
  },
  {
    "name": "Mahabaleshwar Taxi from Pune",
    "description": "Mahabaleshwar Taxi from Pune provides a convenient and stress-free way to travel from Pune to the popular hill station. Well-maintained, air-conditioned taxis with comfortable interiors ensure a pleasant journey through scenic routes. Experienced drivers handle mountain roads with care, making the trip safe and enjoyable. Suitable for families, groups, and solo travelers, this service guarantees comfort, reliability, and punctual travel."
  },
  {
    "name": "AC Taxi Pune to Mahabaleshwar",
    "description": "AC Taxi Pune to Mahabaleshwar ensures a cool and comfortable journey, especially during summer and peak travel seasons. Fully air-conditioned vehicles offer spacious seating, smooth ride quality, and sufficient luggage space. Professional chauffeurs provide safe driving and efficient route planning, allowing passengers to relax and enjoy the scenic beauty en route. Ideal for families, tourists, and couples seeking comfort and convenience."
  },
  {
    "name": "Luxury Taxi Mahabaleshwar",
    "description": "Luxury Taxi Mahabaleshwar delivers a premium travel experience with stylish, high-end vehicles and modern interiors. Fully air-conditioned luxury taxis offer superior comfort, smooth rides, and a refined atmosphere for long-distance travel. Professional chauffeurs ensure punctuality, safety, and personalized service. Perfect for couples, corporate travelers, or families looking for a high-end journey from Pune to Mahabaleshwar."
  },
  {
    "name": "Family Taxi Mahabaleshwar",
    "description": "Family Taxi Mahabaleshwar is specially designed for families traveling together to the hill station. Spacious taxis with air-conditioning, comfortable seating, and ample luggage space ensure a relaxed journey for all age groups. Experienced drivers prioritize safety and smooth driving on ghat roads. Ideal for family vacations, weekend getaways, or holiday trips with complete peace of mind."
  },
  {
    "name": "Outstation Taxi Mahabaleshwar",
    "description": "Outstation Taxi Mahabaleshwar offers a dependable solution for long-distance travel from Pune. Fully air-conditioned, well-maintained vehicles with professional chauffeurs ensure a smooth and secure journey. Suitable for one-way or round trips, this service is ideal for tourists, families, and corporate travelers seeking reliable outstation travel with flexible scheduling."
  },
  {
    "name": "Affordable Taxi Mahabaleshwar",
    "description": "Affordable Taxi Mahabaleshwar provides budget-friendly travel options without compromising on comfort or safety. Air-conditioned taxis with professional drivers ensure a pleasant journey at economical rates. Ideal for students, families, and group travelers, this service combines affordability, reliability, and convenience for trips from Pune to Mahabaleshwar."
  },
  {
    "name": "Chauffeur Driven Taxi Mahabaleshwar",
    "description": "Chauffeur Driven Taxi Mahabaleshwar ensures a stress-free travel experience with experienced drivers handling navigation, traffic, and ghat road driving. Spacious, air-conditioned vehicles allow passengers to relax and enjoy the journey. Suitable for families, tourists, and corporate travelers, this service focuses on professionalism, safety, and comfort throughout the trip."
  },
  {
    "name": "Best Taxi Pune to Mahabaleshwar",
    "description": "Best Taxi Pune to Mahabaleshwar offers a premium and reliable travel experience with well-maintained vehicles and professional chauffeurs. Fully air-conditioned taxis ensure comfort on long drives, while timely pickups and safe driving enhance convenience. Ideal for families, couples, and tourists seeking the best travel option for Mahabaleshwar trips."
  },
  {
    "name": "Pune Mahabaleshwar Cab",
    "description": "Pune Mahabaleshwar Cab is a dependable travel option for passengers planning a relaxed hill station journey. Spacious, air-conditioned cabs with experienced drivers provide comfort, safety, and punctuality. Flexible pickup and drop locations make this service suitable for families, groups, and tourists planning leisure or weekend trips."
  },
  {
    "name": "Tourist Taxi Mahabaleshwar",
    "description": "Tourist Taxi Mahabaleshwar is ideal for travelers planning sightseeing, leisure travel, or holiday trips. Comfortable, air-conditioned taxis with knowledgeable chauffeurs ensure smooth travel and local route familiarity. Suitable for families, couples, and groups, this service supports flexible itineraries and enjoyable long-distance journeys."
  },
  {
    "name": "Hill Station Taxi Pune",
    "description": "Hill Station Taxi Pune specializes in comfortable and safe travel to popular hill stations like Mahabaleshwar. Air-conditioned vehicles with strong performance and experienced drivers ensure smooth rides on hilly terrain. Ideal for weekend trips, vacations, and leisure travel, this service focuses on safety, comfort, and reliability."
  },
  {
    "name": "Weekend Trip Taxi Mahabaleshwar",
    "description": "Weekend Trip Taxi Mahabaleshwar is perfect for short getaways from Pune. Fully air-conditioned taxis with comfortable seating make weekend travel relaxing and enjoyable. Professional chauffeurs ensure timely departures and safe driving, allowing travelers to make the most of their weekend escape to Mahabaleshwar."
  },
  {
    "name": "Online Taxi Booking Pune",
    "description": "Online Taxi Booking Pune allows travelers to easily book taxis for Mahabaleshwar trips anytime, anywhere. Users can choose vehicle type, pickup and drop locations, travel dates, and trip type with instant confirmation. Fully air-conditioned vehicles and professional chauffeurs ensure a smooth, safe, and reliable journey with complete booking convenience."
  },
  {
    "name": "Mahabaleshwar Travel Taxi",
    "description": "Mahabaleshwar Travel Taxi provides a comfortable and reliable solution for complete travel needs to the hill station. Air-conditioned, well-maintained vehicles with experienced chauffeurs ensure safe navigation and timely arrivals. Ideal for families, tourists, and groups, this service guarantees a pleasant, memorable, and hassle-free Mahabaleshwar travel experience."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Taxi Service", "Mahabaleshwar Taxi from Pune"],
  ["AC Taxi Pune to Mahabaleshwar", "Luxury Taxi Mahabaleshwar"],
  ["Family Taxi Mahabaleshwar", "Outstation Taxi Mahabaleshwar"],
  ["Affordable Taxi Mahabaleshwar", "Chauffeur Driven Taxi Mahabaleshwar"],
  ["Best Taxi Pune to Mahabaleshwar", "Pune Mahabaleshwar Cab"],
  ["Tourist Taxi Mahabaleshwar", "Hill Station Taxi Pune"],
  ["Weekend Trip Taxi Mahabaleshwar", "Online Taxi Booking Pune"],
  ["Mahabaleshwar Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Taxi Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable taxi services from Pune to Mahabaleshwar, ideal for family trips, weekend getaways, and hill station excursions."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced taxis for a smooth and enjoyable journey from Pune to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune to Mahabaleshwar routes, ensuring safe, punctual, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Mahabaleshwar taxi services, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized taxi packages based on your Pune to Mahabaleshwar travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All taxis are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Mahabaleshwar taxi service."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide taxi services from Pune to Mahabaleshwar?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable taxi services from Pune to Mahabaleshwar.'
  },
  {
    question: 'How can I book a Pune to Mahabaleshwar taxi?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of taxis are available for Pune to Mahabaleshwar travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the Pune to Mahabaleshwar journey.'
  },
  {
    question: 'Are drivers experienced with the Pune–Mahabaleshwar route?',
    answer: 'Yes, our professional drivers are familiar with the highway and hill routes to ensure safe and smooth travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup point in Pune and drop-off at Mahabaleshwar.'
  },
  {
    question: 'Is the taxi service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock taxi services to match your travel schedule.'
  },
  {
    question: 'Are the vehicles sanitized before the trip?',
    answer: 'Yes, all taxis are thoroughly cleaned and sanitized before each journey to ensure safety.'
  },
  {
    question: 'What payment options are available for taxi bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Mahabaleshwar trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'Booked a taxi from Pune to Mahabaleshwar with Sanavi Travels. Very comfortable ride, punctual pickup, and excellent service!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Great experience! Clean taxi, professional driver, and smooth journey to Mahabaleshwar. Highly recommend Sanavi Travels.',
    rating: 5
  }
];
























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Taxi Service - Sanavi Travels",
  "description": "Book Pune to Mahabaleshwar taxis with Sanavi Travels. AC and luxury taxis for family trips, outstation journeys, hill station travel, weekend trips, tourist travel, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Mahabaleshwar Taxi Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury taxis from Pune to Mahabaleshwar with Sanavi Travels. Ideal for family trips, outstation journeys, hill station travel, weekend trips, tourist travel, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwartaxiservice;